import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import styled from 'styled-components';

export const StyledTab = styled(Tab)`
  &&& {
    &.Mui-selected {
      background: ${({ theme }) => theme.colorActive};
      border-radius: 25px;
      min-height: 40px;
      color: white;
      /* transition: background-color color 0.2s ease; */
      transition: background-color 0.3s ease-out, color 0.15s ease;
    }

    &.MuiTab-fullWidth {
      margin: 5px;
    }
  }
`;

export const StyledTabs = styled(Tabs)`
  &&& {
    &.MuiTabs-root {
      color: black;
      background: white;
      border-radius: 25px;
      box-shadow: rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px;
    }
    .MuiTabs-indicator {
      display: none;
    }
  }
`;
